<!-- Home.vue -->
<template>
  <div class="preloader-area" :show="displayLoader">
    <div class="preloader__image"></div>
  </div>

  <HomeBanner />

  <!-- class area start here -->
  <section class="bd-class-area pt-120 pb-20">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="bd-section-title-wrapper text-center mb-55 wow fadeInUp" data-wow-duration="1s"
            data-wow-delay=".2s">
            <h2 class="bd-section-title mb-0">Holistic Education</h2>
            <p>A Co-Educational English Medium School providing holistic education at an affordable cost</p>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <!-- Programs Column -->
          <div class="col-md-6 mb-4">
            <div class="bd-class-wrapper-2 text-center p-4">
              <div class="bd-class-2">
                <div class="bd-class-icon-wrapper mb-3">
                  <div class="bd-class-icon-2">
                    <i class="fa fa-graduation-cap fa-2x"></i>
                  </div>
                </div>
                <div class="bd-class-content">
                  <h3 class="bd-class-title"><a href="program.html" class="text-dark text-decoration-none">Programs</a>
                  </h3>
                  <p>At Vedanta Gurukul Public School, we are dedicated to delivering quality education at an affordable
                    fee.</p>
                  <div class="bd-class-btn mt-3">
                    <a href="program.html" class="bd-btn bd-btn-grey btn btn-secondary">
                      View Details
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Achievements Column -->
          <div class="col-md-6 mb-4">
            <div class="bd-class-wrapper-2 text-center p-4">
              <div class="bd-class-2">
                <div class="bd-class-icon-wrapper mb-3">
                  <div class="bd-class-icon-2">
                    <i class="fa fa-trophy fa-2x"></i>
                  </div>
                </div>
                <div class="bd-class-content">
                  <h3 class="bd-class-title"><a href="board_result.html"
                      class="text-dark text-decoration-none">Achievements</a></h3>
                  <p>Over the journey of 15 years, Vedanta Gurukul Public School has achieved numerous milestones.</p>
                  <div class="bd-class-btn mt-3">
                    <a href="board_result.html" class="bd-btn bd-btn-grey btn btn-secondary">
                      View Details
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- class area end here -->

  <!-- promotion area start here  -->
  <section class="bd-promotion-area pb-60">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-xl-6 col-lg-6">
          <div class="bd-promotion-thumb-wrapper mb-60">
            <div class="bd-promotion-thumb">
              <div class="bd-promotion-thumb-maskx p-relative wow fadeInLeft" data-wow-delay=".3s"
                data-wow-duration="1">
                <img src="/img/home/school_bldg.png" alt="Image not found">
                <div class="panel wow"></div>
              </div>
            </div>
            <div class="bd-promotion-shape d-none d-lg-block">

            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6">
          <div class="bd-promotion mb-60 wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s">
            <div class="bd-section-title-wrapper mb-35">
              <h2 class="bd-section-title mb-10">Empowering Minds, Enriching Lives</h2>
              <p> A distinguished English Medium, non-profit educational institute pioneering education
                since 2008, helping students to discover their potential.
              </p>
            </div>
            <div class="bd-promotion-counter-wrapper mb-40">
              <div class="bd-promotion-counter">
                <div class="bd-promotion-counter-number">
                  <p><span class="counter">15</span>+</p>
                </div>
                <div class="bd-promotion-counter-text">
                  <span>Years of</span>
                  <span>experience</span>
                </div>
              </div>
              <div class="bd-promotion-counter">
                <div class="bd-promotion-counter-number">
                  <p><span><span class="counter">2</span>K</span>+</p>
                </div>
                <div class="bd-promotion-counter-text">
                  <span>Students</span>
                  <span>each year</span>
                </div>
              </div>
              <div class="bd-promotion-counter">
                <div class="bd-promotion-counter-number">
                  <p><span class="counter">65</span>+</p>
                </div>
                <div class="bd-promotion-counter-text">
                  <span>Qualified</span>
                  <span>Staff</span>
                </div>
              </div>
            </div>
            <div class="bd-promotion-list mb-50">
              <ul>
                <li>A perfect balance between academics and co-curricular activities</li>
                <li>Fostering holistic growth with excellent
                  infrastructure facilities.</li>
              </ul>
            </div>
            <div class="bd-promotion-btn-wrapper flex-wrap">
              <div class="bd-promotion-btn">
                <a href="about_school.html" class="bd-btn">
                  <span class="bd-btn-inner">
                    <span class="bd-btn-normal">Know More</span>
                    <span class="bd-btn-hover">Know More</span>
                  </span>
                </a>
              </div>
              <div class="bd-promotion-btn-2 bd-pulse-btn btn-2">
                <a href="campus.html" class="popup-video"><i class="fa fa-play fa-2"></i> Campus Tour</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- promotion area end here  -->

  <!-- program area start here  -->
  <section class="bd-program-area-2 p-relative fix theme-bg-6 pt-120 pb-120">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="bd-section-title-wrapper text-center mb-35 wow fadeInUp" data-wow-duration="1s"
            data-wow-delay=".2s">
            <h2 class="bd-section-title mb-0">Educational Programs</h2>
            <p>Vedanta Gurukul Public School commenced in 2008
              to empower students in Ringus region, offers formal education from Play Group to 12th
              Standard in
              the streams of Arts, Commerce and Science</p>
          </div>
        </div>
      </div>


      <ProgramsCarousel />



      <!-- program slider dots pagination  -->
      <div class="bd-program-pagination bd-dots-pagination fill-pagination"></div>
    </div>
    <!-- <div class="bd-wave-wrapper bd-wave-wrapper-2">
            <div class="bd-wave bd-wave-2"></div>
            <div class="bd-wave bd-wave-2"></div>
         </div> -->
  </section>
  <!-- program area end here -->

  <!-- faq area start here  -->
  <section class="bd-faq-area pt-120 pb-60">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-xl-6 col-lg-6">
          <div class="bd-faq-content-2 mb-60 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".3s">
            <div class="bd-section-title-wrapper mb-25">
              <h2 class="bd-section-title mb-0" style="font-size: 45px;">Why Study with Us ?
              </h2>
            </div>
            <div class="bd-faq">
              <div class="accordion" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                      Affordable Fees
                    </button>
                  </h2>
                  <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <p>At Vedanta Gurukul Public School, the motto is to bring quality education to
                        one
                        and all, regardless of their economic background.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingTwo">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      Holistic Approach to Education
                    </button>
                  </h2>
                  <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <p>Education at Vedanta School is not limited to the
                        classroom. We believe in a holistic approach that fosters the all-round
                        development of our students.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingThree">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      Scholarship for Meritorious Students
                    </button>
                  </h2>
                  <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                      <p>Vedanta Gurukul Public School's scholarship programs are
                        intended to lubricate the educational journey of students who have exhibited
                        merit despite their tough economic conditions.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6">
          <div class="bd-faq-thumb-wrapper mb-70">
            <div class="bd-faq-thumb">
              <div class="bd-faq-thumb-maskx p-relative wow fadeInRight" data-wow-duration="1s" data-wow-delay=".3s">
                <img src="/img/home/faqs.png" alt="Image not found">
                <div class="panel-2 wow"></div>
              </div>
            </div>
            <div class="bd-faq-shape d-none d-lg-block">

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- faq area end here  -->

  <!-- teacher area start here  -->
  <section class="bd-teacher-area-2 theme-bg">
    <div class="container">
      <div class="bd-teacher-bg-wrapper pt-120 pb-120 p-relative">
        <div class="bd-teacher-bg d-none d-xl-block"></div>
        <div class="bd-teacher-overlay"></div>
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="bd-section-title-wrapper z-index-1 p-relative is-white text-center mb-55 wow fadeInUp"
              data-wow-duration="1s" data-wow-delay=".2s">
              <h2 class="bd-section-title mb-0" style="font-size: 45px;">Exploring Knowledge<br />Outside
                Traditional Boundaries</h2>
              <p>Unlocking Learning in Real-World Experiences and Diverse Perspectives</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="bd-teacher-wrapper">
              <div class="row">
                <div class="col-xl-3 col-lg-6 col-md-6">
                  <div class="bd-teacher-2 p-relative z-index-1 mb-40 wow fadeInUp" data-wow-duration="1s"
                    data-wow-delay=".4s">
                    <div class="bd-teacher-thumb-wrapper-2 mb-20 p-relative">
                      <a href="campus.html">
                        <div class="bd-teacher-thumb-2">
                          <img src="/img/home/infra_1.png" alt="Image not found">
                        </div>
                      </a>

                    </div>
                    <div class="bd-teacher-content-wrapper-2">
                      <div class="bd-teacher-content-2 text-center">
                        <h4 class="bd-teacher-title-2 mb-5"><a href="campus.html">Digital
                            Teaching</a>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6">
                  <div class="bd-teacher-2 p-relative z-index-1 mb-40 wow fadeInUp" data-wow-duration="1s"
                    data-wow-delay=".5s">
                    <div class="bd-teacher-thumb-wrapper-2 mb-20 p-relative">
                      <a href="campus.html">
                        <div class="bd-teacher-thumb-2">
                          <img src="/img/home/infra_2.png" alt="Image not found">
                        </div>
                      </a>

                    </div>
                    <div class="bd-teacher-content-wrapper-2">
                      <div class="bd-teacher-content-2 text-center">
                        <h4 class="bd-teacher-title-2 mb-5"><a href="campus.html">Computer Lab</a>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6">
                  <div class="bd-teacher-2 p-relative z-index-1 mb-40 wow fadeInUp" data-wow-duration="1s"
                    data-wow-delay=".6s">
                    <div class="bd-teacher-thumb-wrapper-2 mb-20 p-relative">
                      <a href="campus.html">
                        <div class="bd-teacher-thumb-2">
                          <img src="/img/home/infra_3.png" alt="Image not found">
                        </div>
                      </a>

                    </div>
                    <div class="bd-teacher-content-wrapper-2">
                      <div class="bd-teacher-content-2 text-center">
                        <h4 class="bd-teacher-title-2 mb-5"><a href="campus.html">Student Safety</a>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-lg-6 col-md-6">
                  <div class="bd-teacher-2 p-relative z-index-1 mb-40 wow fadeInUp" data-wow-duration="1s"
                    data-wow-delay=".7s">
                    <div class="bd-teacher-thumb-wrapper-2 mb-20 p-relative">
                      <a href="campus.html">
                        <div class="bd-teacher-thumb-2">
                          <img src="/img/home/infra_4.png" alt="Image not found">
                        </div>
                      </a>

                    </div>
                    <div class="bd-teacher-content-wrapper-2">
                      <div class="bd-teacher-content-2 text-center">
                        <h4 class="bd-teacher-title-2 mb-5"><a href="campus.html">Playground</a>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bd-teacher-view-btn p-relative z-index-1 text-center mt-10">
                <a href="campus.html">More on Campus</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- teacher area end here  -->

  <!-- testimonial area start here  -->
  <section class="bd-testimonial-area-2 pb-120 pt-120">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="bd-section-title-wrapper z-index-1 p-relative text-center mb-55">
            <h2 class="bd-section-title mb-0">Voices of Praise</h2>
            <p>Testimonials from Parents, Students, and Staff</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-6">
          <div class="bd-testimonial-2-wrap">
            <div class="bd-testimonial-2 theme-bg-6 mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
              <div class="bd-testimonial-rating mb-30">
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
              </div>
              <div class="bd-testimonial-content-2 mb-35">
                <p>I have scored 92.67% in my board exam. This is because of the teaching done by our teachers at VGPS.
                  They are very good. In addition to preparing for boards, the curriculum also prepared me for Olympiads
                  and other competitive exams. VGPS also helped me improve my communication skills along with boosting
                  my confidence. After my experience and results, I can confidently say that my school is the best
                  school in Reengus.</p>
              </div>
              <div class="bd-testimonial-avatar d-flex align-items-center">
                <div class="bd-testimonial-avatar-thumb">
                  <!-- <img src="/img/testimonials/2.png" alt="testimonial avatar"> -->
                </div>
                <h6 class="bd-testimonial-avatar-title-2 mb-0">GARIMA SHEKHAWAT ( 10th ) ( 92.67%)</h6>
                <div class="bd-testimonial-quote d-none d-sm-block clr-2">
                  <i class="fa fa-quote-right"></i>
                </div>
              </div>
            </div>
            <div class="bd-testimonial-2 theme-bg-6 mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s">
              <div class="bd-testimonial-rating mb-30">
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
              </div>
              <div class="bd-testimonial-content-2 mb-35">
                <p>Great and satisfying teaching techniques are what set VGPS apart from other schools. The teachers
                  made sure that we focused on our co-curricular activities in addition to our studies. The key points
                  that helped us achieve more than just grades were regular tests, clear explanations, and addressing
                  doubts. I would like to conclude by expressing how proud I am to be a student of this school.</p>

              </div>
              <div class="bd-testimonial-avatar d-flex align-items-center">
                <div class="bd-testimonial-avatar-thumb">
                  <!-- <img src="/img/testimonials/2.png" alt="testimonial avatar"> -->
                </div>
                <h6 class="bd-testimonial-avatar-title-2 mb-0">PRIYA SHARMA (10th) ( 92.50% )</h6>
                <div class="bd-testimonial-quote d-none d-sm-block clr-2">
                  <i class="fa fa-quote-right"></i>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6">
          <div class="bd-testimonial-2-wrap">
            <div class="bd-testimonial-2 theme-bg-6 mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s">
              <div class="bd-testimonial-rating mb-30">
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
              </div>
              <div class="bd-testimonial-content-2 mb-35">
                <p>It has been a truly invaluable learning experience in this school with digital classrooms. As for the
                  assistance, feedback, and general help of teachers, I have found it excellent. The feedback on
                  assignments is constructive and to the point, yet always positive and motivating. All the teachers are
                  very patient and supportive, consistently motivating students to do their best in life.</p>
              </div>
              <div class="bd-testimonial-avatar d-flex align-items-center">
                <div class="bd-testimonial-avatar-thumb">
                  <!-- <img src="/img/testimonials/2.png" alt="testimonial avatar"> -->
                </div>
                <h6 class="bd-testimonial-avatar-title-2 mb-0">CHETAN KUMAWAT 12th ( Sc./Math ) ( 91.80 )</h6>
                <div class="bd-testimonial-quote d-none d-sm-block clr-2">
                  <i class="fa fa-quote-right"></i>
                </div>
              </div>
            </div>
            <div class="bd-testimonial-2 theme-bg-6 mb-25 wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s">
              <div class="bd-testimonial-rating mb-30">
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
                <a href="#"><i class="fas fa-star"></i></a>
              </div>
              <div class="bd-testimonial-content-2 mb-35">
                <p>I am proud to be a student of VGPS. All the teachers have been really good. They have motivating
                  attitude, help us to enjoy learning and always encourage us to face the different challenges of life.
                  This school has refined me as person, polished me and I have been able to hone my skills. It has been
                  made me one of the most efficient and effective performers. I have gained valuable skills and
                  knowledge because of which I am now able to face any challenge in my life.</p>
              </div>
              <div class="bd-testimonial-avatar d-flex align-items-center">
                <div class="bd-testimonial-avatar-thumb">
                  <!-- <img src="/img/testimonials/2.png" alt="testimonial avatar"> -->
                </div>
                <h6 class="bd-testimonial-avatar-title-2 mb-0">HARSH SHARMA 12th ( Commerce ) (95.80% )
                </h6>
                <div class="bd-testimonial-quote d-none d-sm-block clr-2">
                  <i class="fa fa-quote-right"></i>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- testimonial area end here  -->

  <!-- joining area start here  -->
  <section class="bd-joining-area pt-100 pb-95">
    <!-- joiniong bg -->
    <div class="bd-joining-bg" :style="{ backgroundImage: 'url(/img/home/bg_1.png)' }"></div>

    <!-- joining bg overlay -->
    <div class="bd-joining-bg-overlay"></div>
    <div class="container">
      <div class="bd-joining">
        <div class="bd-joining-shape-wrapper d-none d-md-block">
          <div class="bd-joining-shape-1 p-absolute">

          </div>
          <div class="bd-joining-shape-2 p-absolute">

          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="bd-joining-content text-center">
              <div class="bd-section-title-wrapper is-white mb-45 wow fadeInUp" data-wow-duration="1s"
                data-wow-delay=".3s">
                <h2 class="bd-section-title mb-0">Join Our New Session</h2>
                <p>Secure your child's path to success in the nation's future</p>
              </div>
              <div class="bd-joining-btn">
                <a href="https://rgs.eshala.co.in/page/enquiry" class="bd-btn btn-white">
                  <span class="bd-btn-inner">
                    <span class="bd-btn-normal">Contribute</span>
                    <span class="bd-btn-hover">Contribute</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- bd-joining-bottom-line -->
    <div class="bd-joining-line"></div>
    <div class="bd-joining-line-2"></div>
  </section>
  <!-- joining area end here  -->

  <!-- gallery area start here  -->
  <section class="bd-gallery-area p-relative pt-120 pb-60 p-relative">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="bd-section-title-wrapper mb-55 text-center wow fadeInUp" data-wow-duration="1s"
            data-wow-delay=".3s">
            <h2 class="bd-section-title mb-0" style="font-size: 45px;">Glimpse of <br />Vedanta Gurukul
              Public School</h2>
            <p>Explore captivating moments in our gallery</p>
          </div>
        </div>
      </div>
      <HomeGalleryCarousel />
    </div>
  </section>


</template>

<script>
import HomeBanner from "@/components/HomeBanner";
import ProgramsCarousel from "@/components/ProgramsCarousel";
import HomeGalleryCarousel from '@/components/HomeGalleryCarousel';

export default {
  name: "HomePage",
  components: {
    HomeBanner,
    ProgramsCarousel,
    HomeGalleryCarousel
  },
  mounted() {
    this.displayLoader = false;
  },

};
</script>
